import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const INTERNAL_MEDICINE_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_INTERNAL_MEDICINE>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.diagnoses,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.anamnesis,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.physicalStatus,
  },
  {
    key: "clinical_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.clinicalCourse,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .additionalDiagnosticFindings,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .dischargeMedications,
  },
  {
    key: "social_anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.socialAnamnesis,
  },
];

export function createInternalMedicineDischargeLetterPdf(
  props: PdfCreatorProps<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_INTERNAL_MEDICINE
  >,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_INTERNAL_MEDICINE
  >(props, INTERNAL_MEDICINE_FIELD_CONFIG);
}
